<template>
	<v-container grid-list-md class="pa-0">
		<v-layout row wrap>
			<v-container>
				<v-flex xs12 md12>
					<v-card>
						<v-card-title primary-title>
							{{ $t("title.outlet") }}
							<v-btn
								@click="getItems()"
								text
								class="mr-2"
								icon
								:loading="loading ? loading : false"
							>
								<v-icon>mdi-reload</v-icon>
							</v-btn>
							<v-spacer></v-spacer>
							<filter-monthly-order
								v-model="filter"
								@filter="onFilter()"
							></filter-monthly-order>
						</v-card-title>
						<v-divider></v-divider>
						<v-card-text>
							<v-simple-table>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left">
												{{ $t("Name") }}
											</th>
											<th class="text-left">
												{{ $t("title.reservation") }}
											</th>
											<th class="text-left">
												{{ $t("title.order") }}
											</th>
											<th class="text-left">
												{{ $t("label.order_total") }}
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												data, index
											) in data.outlets"
											:key="index"
										>
											<th>{{ data.name }}</th>
											<th>
												{{ data.count_reservation }}
											</th>
											<th>{{ data.count_order }}</th>
											<th>
												{{
													data.total_order | currency
												}}
											</th>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-container>
		</v-layout>
	</v-container>
</template>
<script>
import TenantLayout from "../../../layouts/tenant.vue";
import TenantReportLayout from "../../../layouts/partials/tenant/report.vue";
import { Link } from "@inertiajs/inertia-vue";
import pickBy from "lodash/pickBy";
export default {
	layout: [TenantLayout, TenantReportLayout],
	components: {
		Link,
	},
	props: ["data", "name", "count_order", "count_reservation", "total_order"],
	data() {
		return {
			datas: [],
			datas: [],
			loading: false,
			filter: {
				date: new Date().toISOString().substr(0, 7),
			},
		};
	},
	computed: {
		endpoint() {
			return this.$route(
				"tenant.reports.outlet.index",
				this.$page.props.tenant.id
			);
		},
	},
	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
	},
};
</script>